export default __webpack_public_path__ + "landing-page-newsletter-form-blob-1.svg";